import React from 'react';
import { useDispatch } from 'react-redux';
import { KTCard } from '../../_metronic/helpers/components/KTCard';
import { KTCardBody } from '../../_metronic/helpers/components/KTCardBody';
import { storeEbbeModalCallback } from '../../redux/reducers/authSlice';
import QrEtiket from './QrEtiket';
import { qrYazdir } from './qrYazdir';

interface Props {
    /** Kart başlığı (ör. "QR Kodu", "Araç QR"). */
    kartBasligi: string
    /** Etiket başlığı: nokta adı ya da plaka. */
    baslik: string
    qrMetni: string
    qrKodu: string
    /** "QR'ı yenile" onaylanınca çağrılır. */
    onYenile: () => void
    /** Kartın altındaki açıklama. */
    aciklama?: string
    cardRef?: any
}

/**
 * Kayıt ekranında QR bölümü (11.10.2026): QR önizleme + kısa kod + "QR Yazdır" + "QR'ı yenile".
 * Yenileme onay ister; eski etiket çalışmaz hale gelir.
 */
const QrKarti = ({ kartBasligi, baslik, qrMetni, qrKodu, onYenile, aciklama, cardRef }: Props) => {
    const dispatch = useDispatch();

    const yenileOnayi = () => {
        dispatch(storeEbbeModalCallback({
            title: 'Emin Misiniz?',
            body: 'QR yenilenirse eski etiket çalışmaz. Devam edilsin mi?',
            buttons: [
                {
                    text: 'Hayır',
                    btnClass: 'btn-danger',
                },
                {
                    text: 'Evet',
                    btnClass: 'btn-success',
                    onClick: onYenile
                }
            ]
        }))
    }

    return (
        <div className='containerPart' ref={cardRef}>
            <KTCard className="ebbe-card mt-10">
                <KTCardBody>
                    <h4 className="mb-10 text-black">{kartBasligi}</h4>

                    <div className="d-flex flex-wrap align-items-center gap-10">
                        <QrEtiket qrMetni={qrMetni} baslik={baslik} qrKodu={qrKodu} />

                        <div className="d-flex flex-column gap-3">
                            <div>
                                <label className="form-label">QR Kodu</label>
                                <div className="fw-bolder fs-3 text-gray-800" style={{ letterSpacing: 2 }}>{qrKodu}</div>
                            </div>

                            <div className="d-flex gap-3">
                                <button type="button" className="btn btn-sm fw-bold btn-light-primary" onClick={() => qrYazdir([{ baslik, qrMetni, qrKodu }])}>
                                    <i className="fa fa-print me-1" />
                                    QR Yazdır
                                </button>

                                <button type="button" className="btn btn-sm fw-bold btn-light-danger" onClick={yenileOnayi}>
                                    <i className="fa fa-sync-alt me-1" />
                                    QR'ı yenile
                                </button>
                            </div>
                        </div>
                    </div>

                    {
                        aciklama && (
                            <div className="text-muted fs-7 mt-5">{aciklama}</div>
                        )
                    }
                </KTCardBody>
            </KTCard>
        </div>
    )
}

export default QrKarti;
